import Repository from "../Repository";

const resource = "/mediums";
export default {
    get(){
        return Repository.get(`${resource}`);
    },
    getMedium(mediumId){
        return Repository.get(`${resource}/${mediumId}`);
    },
    createMedium(json){
        return Repository.post(`${resource}`,json);
    },
    updateMedium(mediumId,json){
        return Repository.put(`${resource}/${mediumId}`,json);
    },
    deleteMedium(mediumId){
        return Repository.delete(`${resource}/${mediumId}`);
    }
}